<template>
  <div class="halaman-admin">
    <div>
      <!-- Bootstrap Modal -->
      <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Konfirmasi Hapus</h5>
              <i class="bi bi-x-square"></i>
            </div>
            <div class="modal-body">
              Apakah Anda yakin ingin menghapus kontingen ini?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Batal</button>
              <button type="button" class="btn btn-danger" @click="deleteContingent">Ya, hapus</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard-container">
      <div
        v-if="loading"
        class="progress-bar"
        :style="{ width: progress + '%' }"
      ></div>

      <div class="mb-2 page-title">
        <i class="bi bi-file-earmark-text"></i> Tanding
      </div>

      <div class="mb-2 d-flex justify-content-end align-items-center">
        <!-- Search Bar -->
     
        <!-- Create Menu Button -->
        <router-link to="/admin/tanding/create" class="button button-primary">
          <i class="bi bi-plus-square"></i> Tambah
        </router-link>
      </div>

      <!-- Table to display navigation data -->
      <div class="table-responsive mt-3">
        <table class="table mb-0">
          <thead>
            <tr class="table-header">
              <th colspan="7" class="header">
                <select v-model="selectedTournament" @change="loadPools" class="form-select w-auto d-inline-block me-2">
                  <option value="">Semua Turnamen</option>
                  <option v-for="tournament in tournaments" :key="tournament.id" :value="tournament.id">
                    {{ tournament.name }}
                  </option>
                </select>
              </th>
              <th class="header text-end">
                <button
                  v-if="selectedTournament"
                  class="btn btn-success btn-sm"
                  @click="goToMatchRecap"
                >
                  <i class="bi bi-table"></i> Matches
                </button>

             
              </th>
            </tr>
            <tr>
              <th>Turnamen</th>
              <th>Pool</th>
              <th>Kategori Pertandingan</th>
              <th>Kelompok Usia</th>
              <th>Kelas</th>
              <th>Ukuran Bagan</th>
              <th>Status Bagan</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody v-if="pools.length > 0">
            <tr v-for="pool in pools" :key="pool.pool_id">
            
         
              <td class="kolom-turnamen">{{ pool.tournament_name }}</td>
              <td>{{ pool.name }}</td>
              <td>{{ pool.match_category }}</td>
              <td>{{ pool.age_category }}</td>
             <td>
                <template v-if="pool.category_class && pool.category_class?.name">
                  <div class="text-success">
                    {{ { male: 'Putra', female: 'Putri' }[pool.category_class?.gender] || pool.category_class?.gender }} — {{ pool.category_class?.name }}
                    ({{ Number(pool.category_class?.weight_min) }}–{{ Number(pool.category_class?.weight_max) }} kg)
                  </div>
                </template>
                <template v-else>
                  -
                </template>
              </td>


              <td class="text-center">
                {{ pool.match_chart === 0 ? 'Full Prestasi' : pool.match_chart }}
              </td>

              <td>
                <span v-if="pool.matches_count > 0" class="badge bg-success p-2">Sudah dibuat</span>
                <span v-else class="badge bg-warning text-dark p-2">Belum dibuat</span>
              </td>

              <td class="action-column">
                <div class="d-flex gap-2 justify-content-end">
          <MenuAksi v-slot="{ tutup }">
            <button type="button" class="aksi__item"
                    @click="tutup(); GenerateMatch(pool.pool_id)">
              <i class="bi bi-diagram-3"></i> 
                          <span v-if="pool.matches_count > 0"> Lihat Bagan</span>
                          <span v-else> Buat Bagan</span>
            </button>
            <button type="button" class="aksi__item"
                    @click="tutup(); ViewMatch(pool.pool_id)">
              <i class="bi bi-eye"></i> Lihat Partai
            </button>
          </MenuAksi>
        </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7" class="text-center">Belum ada data.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
    <!--
      BILAH HALAMAN DIHAPUS.

      Blok paginasi di sini hasil salin-tempel dari halaman lain dan tidak
      pernah disambungkan: `changePage`, `currentPage`, `totalPages`,
      `prevPageUrl`, dan `nextPageUrl` tidak ada satu pun di dalam skrip
      berkas ini, dan endpoint yang dipanggilnya memang tidak memaginasi
      apa-apa.

      Akibatnya bilah itu tampil sebagai dua panah kelabu yang tidak bisa
      ditekan, tanpa nomor halaman — kontrol yang tidak mungkin berfungsi,
      tapi terlihat seperti ada gunanya. Kalau nanti datanya benar-benar
      dipaginasi, pasang komponen paginasi yang sama dengan halaman lain,
      jangan salin blok ini lagi.
    -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import API from "@/config/api";
import MenuAksi from "@/components/ui/MenuAksi.vue";
import { Modal } from "bootstrap";
import { useToast } from "vue-toastification";
import { inject } from 'vue';

axios.defaults.baseURL = API.API_BASE_URL;

export default {
  name: "ContingentList",

  components: { MenuAksi },
  data() {
    return {
      poolId: null,
      deleteModal: null,
      pools: [],
      loading: false,
      progress: 0,
      tournaments: [],
      selectedTournament: '',
    };
  },

  setup() {
    const toast = useToast();
    const permissions = inject('permissions', []); // Ensure permissions is always an array
    
    return { toast, permissions };
  },
  mounted() {
    this.loadTournaments();
    this.loadPools(); // Corrected the method name
    this.deleteModal = new Modal(document.getElementById("confirmDeleteModal"));
  },
    methods: {
    goToMatchRecap() {
      this.$router.push({
        name: "MatchRecap",
        params: {
          tournament_id: this.selectedTournament
        },
      });
    },
    formatMatchCount(count) {
      const matchLabel = count === 1 ? 'Match' : 'Matches';
      const athleteLabel = count * 2 === 1 ? 'Athlete' : 'Athletes';
      return `${count} ${matchLabel} (${count * 2} ${athleteLabel})`;
    },
    confirmDelete(id) {
      this.poolId = id;
      this.deleteModal.show();
    },

    async loadTournaments() {
      try {
        const response = await axios.get("/tournaments/active", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });
        this.tournaments = response.data;
      } catch (error) {
        console.error("Failed to load tournaments:", error);
      }
    },

    
    async loadPools() {
      this.loading = true;
      try {
        const response = await axios.get("/pools", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          params: {
            tournament_id: this.selectedTournament || undefined,
          },
        });
        this.pools = response.data.data;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.loading = false;
      }
    },


    GenerateMatch(id) {
      this.$router.push({ name: "GenerateMatch", params: { id } });
    },
    ViewMatch(id) {
      this.$router.push({ name: "ViewMatch", params: { id } });
    },
  },
};
</script>

<style scoped>

.table th,
.table td {
  padding: 10px;
}




input::placeholder {
    color: var(--text-muted);
    font-size: 15px;  /* Change font size */
    font-style: italic;  /* Change font style */
    opacity: 1;  /* Full opacity (default is 0.5) */
    font-family: 'Figtree', sans-serif;
}




.form-control {
  width: 250px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}

/* Animasi garis loader */
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
